import { Field, ID, InputType } from 'type-graphql'
import { ActionArgs } from '../../action/ActionArgs'
import type { IAction } from '../../action/IAction'
import { ShippingRate } from '../../shipping/ShippingRate'
import { ShippingBillTo } from '../../shipping/ShippingBillTo'
import type { Order } from '../Order'

export interface ISetShippingRate extends IAction<Order, SetShippingRateArgs> {}

@InputType()
export class SetShippingRateArgs extends ActionArgs {
  @Field(() => ID)
  orderId: string

  @Field(() => ShippingRate)
  rate: ShippingRate

  @Field(() => ShippingBillTo)
  billTo?: ShippingBillTo

  @Field(() => Date)
  shippingDate?: Date
}
